export { default } from './icon'
